import { NavLink } from "react-router-dom";
import { Flower, ScrollText, Feather, TreeDeciduous, Users, BookOpen, Newspaper, Shield } from "lucide-react";

// ObituariesTabs — a compact horizontal "sibling pages" strip that lets
// visitors hop between Obituaries Hub · Chronological Archive · Submit
// · Family Tree Guide · Memorial Directory. Rendered at both the top
// and the bottom of every Obituary/Memorial-adjacent page so people who
// scroll to the end still see all the related destinations.
//
// The component is site-agnostic — it renders the same on Social Pulse,
// myfamilytree.care, and indianfamilytree.com because all three share
// the same backend routes.

const TABS = [
  { to: "/obituaries/hub",       label: "Obituaries Hub",     icon: BookOpen,       testid: "obit-tab-hub" },
  { to: "/obituaries",           label: "Recent Obituaries",  icon: Newspaper,      testid: "obit-tab-recent", exact: true },
  { to: "/obituaries/submit",    label: "Submit Obituary",    icon: Feather,        testid: "obit-tab-submit" },
  { to: "/obituaries/category/veterans", label: "Veterans", icon: Shield,           testid: "obit-tab-veterans" },
  { to: "/celebrate",            label: "Memorial Directory", icon: Flower,         testid: "obit-tab-memorials" },
  { to: "/family-tree-guide",    label: "Family Tree Guide",  icon: TreeDeciduous,  testid: "obit-tab-guide" },
  { to: "/heritage",             label: "Family & Memorials", icon: Users,          testid: "obit-tab-heritage" },
];

export default function ObituariesTabs({ position = "top" }) {
  return (
    <nav
      data-testid={`obituaries-tabs-${position}`}
      aria-label="Obituaries and memorials navigation"
      className={
        "flex items-center gap-2 flex-wrap py-3 " +
        (position === "top"
          ? "border-b mb-6"
          : "border-t mt-10 pt-4")
      }
      style={{ borderColor: "var(--wofy-border)" }}
    >
      <ScrollText className="w-4 h-4 opacity-60" />
      <span
        className="text-[10px] font-mono uppercase tracking-widest opacity-60 mr-2 hidden sm:inline"
        aria-hidden="true"
      >
        Related
      </span>
      {TABS.map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.exact}
            data-testid={t.testid}
            className={({ isActive }) =>
              "inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs whitespace-nowrap transition-colors " +
              (isActive
                ? "text-white"
                : "hover:bg-neutral-50")
            }
            style={({ isActive }) =>
              isActive
                ? { background: "var(--wofy-primary)", borderColor: "var(--wofy-primary)" }
                : { borderColor: "var(--wofy-border)" }
            }
          >
            <Icon className="w-3.5 h-3.5" />
            {t.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
